import moment from "moment-timezone";

export const scheduleTooltipFeature = {
    generateTipContent: ({ date }) =>
        `<div style="display:flex;align-items:center; font-size:14px; margin-bottom:5px; padding: 10px 17px;">
                <i style="margin-bottom:2px; margin-right:0.2rem" class=\"b-icon-clock-live\"></i>
                ${moment(date).format("YYYY-MM-DD hh:mm A")}
        </div>`,
}